module.exports = __webpack_public_path__ + "img/innungsfachbetrieb.7fb88d15.png";